import { loadStripe } from "@stripe/stripe-js";

/**
 * Stripe.js singleton, loaded with the PUBLISHABLE key (safe for the browser).
 * Card data is entered in Stripe Elements and sent straight to Stripe — never
 * to our backend (PCI). The backend returns a client_secret which we confirm
 * here with Stripe.js.
 */
export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
);
